"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon24CheckCircleOn", "check_circle_on_24", "0 0 24 24", '<symbol viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="check_circle_on_24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm6.207-14.793a1 1 0 0 0-1.414-1.414L10 14.586l-2.793-2.793a1 1 0 0 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l7.5-7.5Z" fill="currentColor" /></symbol>', 24, 24);
exports.default = _default;
